<template>
    <div class="row justify-content-center">
        <div class="col-sm-5">
            <!--          <div style="height: calc(100vh - 50px);">-->
            <div class="dx-card p-2 mt-2 mb-0">
                <DxAutocomplete
                        :data-source="homeStore.dataSourceSambungan"
                        v-model:value="homeStore.nomorSambungan"
                        :min-search-length="4"
                        placeholder="Angka Terakhir Juga Bisa..."
                        value-expr="nosbg"
                        item-template="sambunganTemplate"
                        class="custom-autocomplete"
                        @item-click="homeStore.onSambunganItemClick"
                        :show-clear-button="true"
                        :input-attr="{ type: 'number' }"
                >
                    <template #sambunganTemplate="{ data }">
                        <span class="fw-bold">{{ data.nosbg }} </span><span class="text-muted"> ({{
                        data.rayon
                        }})</span><br>
                        <span class="text-muted"> {{ data.namalang }}</span>
                    </template>
                </DxAutocomplete>
            </div>

            <div class="d-flex justify-content-center">
                <DxLoadIndicator
                        id="large-indicator"
                        :height="60"
                        :width="60"
                        class="mt-3"
                        :visible="homeStore.isSearchSambunganLoading"
                />
            </div>

            <div v-if=" homeStore.computedSelectedSambungan.nosbg!==null && homeStore.isSearchSambunganLoading === false">
                <h4 class="mt-3">Sambungan</h4>
                <div class="dx-card mt-2 p-2">
                    <span class="text-muted"> {{
                        homeStore.computedSelectedSambungan.nosbg
                        }} / {{ homeStore.computedSelectedSambungan.rayon }}</span>
                    <h5 class="fw-bold mb-0"> {{ homeStore.computedSelectedSambungan.namalang }} <sup><span
                            class="badge bg-secondary"> {{ homeStore.computedSelectedSambungan.gol }}</span></sup></h5>
                    <span class="text-muted"> {{ homeStore.computedSelectedSambungan.alamat }}</span><br>
                    <span v-if="homeStore.infoSambungan!==null" class="text-muted"> {{homeStore.infoSambungan.telepon}}</span><br>

                    <div class="d-flex justify-content-center">
                        <DxLoadIndicator
                                :height="20"
                                :width="20"
                                class="mt-3"
                                :visible="homeStore.isInfoSambunganLoading"
                        />
                    </div>

                    <div class="row justify-content-end mt-2" v-if="homeStore.infoSambungan !== null">
                        <div class="col" v-if=" homeStore.infoSambungan.telepon !== ''">
                            <DxButton
                                    text="Hubungi"
                                    type="default"
                                    icon="tel"
                                    stylingMode="outlined"
                                    @click="homeStore.makePhoneCall"
                            ></DxButton>
                        </div>

                        <div class="col-auto" v-if=" homeStore.infoSambungan.longitude !== null">
                            <DxButton
                                    text="Buka Peta"
                                    type="default"
                                    icon="map"
                                    stylingMode="contained"
                                    @click="homeStore.openGoogleMaps"
                            ></DxButton>
                        </div>
                    </div>

                </div>

                <div class="row mt-3 mb-2">
                    <div class="col">
                        <h4 class="col mb-0">Detail Tagihan</h4>
                        <span v-if="homeStore.daftarTunggakan!=null" class="text-muted">{{homeStore.daftarTunggakan.length}} Tagihan</span></div>
                    <div class="col-auto text-end">
                            <h4 class="mb-0">{{ homeStore.computedTotalTagihan }} </h4><br>
                    </div>
                </div>
                <div class="dx-card pb-3">
                    <DxList
                            :data-source="homeStore.dataSourceMdrd"
                            :search-enabled="false"
                            search-mode="="
                            search-expr="nosbg"
                            :item-render="homeStore.renderItem"
                    >
                        <template #item="{ data }">
                            <div style="padding:4px 0 0 0">
                                <div class="px-3 pt-2">
                                    <div class="row pb-2">
                                        <div class="col-auto">
                                            <h2 class="dx-icon-event m-0"></h2>
                                        </div>
                                        <div class="col ps-2">
                                            <div class=" fw-bold align-middle">
                                                {{ formaterStore.norekStringToReadableMonth((data.norek)) }}
                                            </div>
                                            <span class="text-danger">{{
                                                (data.sts_bayar === "0" ? "Belum Terbayar" : '')
                                                }}
                                            </span>
                                        </div>
                                        <div class="col-auto">
<!--                                            <div class="fw-bold">{{
                                                formaterStore.priceFormat(homeStore.calculateTotalBayar(data))
                                                }}
                                            </div>-->
                                            <div class="text-end text-muted">{{ data.pakai_m3 }} M<sup>3</sup>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row ps-5 bg-light">
                                        <div class="col">
                                            <span class="text-muted">Tarif</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="text-muted">{{
                                                formaterStore.priceFormat(data.jumlahrp)
                                                }}</span>
                                        </div>
                                    </div>
                                    <div class="row mt-1 ps-5">
                                        <div class="col">
                                            <span class="text-muted">Abonemen</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="text-muted">{{ formaterStore.priceFormat(data.danamtr + data.biayaadm + data.abonemen) }}</span>
                                        </div>
                                    </div>
                                    <div class="row mt-1 ps-5 bg-light">
                                        <div class="col">
                                            <span class="text-muted"> Retribusi</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="text-muted">{{ formaterStore.priceFormat(data.retribusi) }}</span>
                                        </div>
                                    </div>
                                    <div class="row mt-1 ps-5">
                                        <div class="col">
                                            <span class="text-muted">Materai</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="text-muted">{{ formaterStore.priceFormat(data.meterai) }}</span>
                                        </div>
                                    </div>
                                    <div class="row mt-1 ps-5 bg-light">
                                        <div class="col">
                                            <span class="text-muted">Denda</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="text-muted">{{ formaterStore.priceFormat(data.denda+data.segel+data.cabut) }}</span>
                                        </div>
                                    </div>
                                    <div class="row mt-1 fw-bold ps-5">
                                        <div class="col">
                                            <span class="">Total Biaya</span>
                                        </div>
                                        <div class="col-auto">
                                            <span class="">{{
                                                    formaterStore.priceFormat(homeStore.calculateTotalBayar(data))
                                                }}</span>
                                        </div>
                                    </div>

                                </div>
                                <hr class="mt-2 mb-0">
                            </div>
                        </template>
                    </DxList>
                </div>
            </div>

            <!--                            <DxAccordion
                                                :collapsible="true"
                                                :multiple="true"
                                                :animation-duration="450"
                                                :data-source="homeStore.dataSourceMdrd"
                                                item-template="isi"
                                                item-title-template="judul"
                                        >
                                            <template #judul="{ data }">
                                                <p>{{ data.norek }}</p>
                                            </template>
                                            <template #isi="{ data }">
                                                {{data.alamat}} The sun gently caressed the tranquil meadow, casting golden hues upon the swaying grass. A soft breeze carried the sweet scent of blooming flowers, creating a symphony of fragrances in the air. Birds chirped melodiously, their songs echoing through the serene landscape. The distant mountains stood tall and proud, their peaks adorned with glistening snow. Time seemed to slow down as nature embraced the moment, painting a picture of tranquility and harmony. It was a scene of pure serenity, where worries faded away, and peace enveloped the soul                    </template>
                                        </DxAccordion>-->

            <!--              <DxList
                              :data-source="homeStore.dataSourceMdrdDataStore"
                              :search-enabled="true"
                              search-mode="="
                              search-expr="nosbg"
                              style="height: 100%"
                          >
                              <template #item="{ data }">
                                  <div style="padding:8px 0 0 0">
                                      <div class="dx-card p-3">
                                          <div class="row">
                                              <div class="col">
                                                  <div class="text-dangerb fw-bold">{{ data.norek }}</div>
                                              </div>
                                          </div>
            &lt;!&ndash;                              <hr>&ndash;&gt;
                                          <div>{{ data.nama }}</div>
                                          <div>{{ data.nosbg }} ({{ data.gol }})</div>
                                          <div>{{ data.alamat }}({{ data.rayon }})</div>
                                          <div>{{ data.pakai_m3 }} M<sup>3</sup></div>
                                          <hr>
                                          <div class="row">
                                              <div class="col">
                                                  <span class="text-muted">Tarif</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.jumlahrp)   }}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted">Dana Meter</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.danamtr)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted"> Biaya Admin</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.biayaadm)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted">Abonemen</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.abonemen)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted"> Retribusi</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.retribusi)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted">Materai</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.meterai)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="text-muted">Denda</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="text-muted">{{ formaterStore.priceFormat(data.denda)}}</span>
                                              </div>
                                          </div>
                                          <div class="row mt-1">
                                              <div class="col">
                                                  <span class="">Total Biaya</span>
                                              </div>
                                              <div class="col-auto">
                                                  <span class="">{{ formaterStore.priceFormat(data.jumlahrp +data.danamtr +data.biayaadm +data.abonemen +data.retribusi +data.meterai +data.denda) }}</span>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </template>
                          </DxList>-->
        </div>
    </div>
</template>
<script setup>
//import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import {useHomeStore} from "@/store/views/home-store";
import {DxAutocomplete} from 'devextreme-vue/autocomplete';
//import DxForm from 'devextreme-vue/form';
import {DxLoadIndicator} from 'devextreme-vue/load-indicator';
import {DxButton} from 'devextreme-vue/button';
//import {DxAccordion} from 'devextreme-vue/accordion';

import DxList from 'devextreme-vue/list';
import {useFormaterStore} from "@/store/utility/formatter-store";

const homeStore = useHomeStore();
const formaterStore = useFormaterStore();

</script>
<style lang="scss">
.custom-autocomplete .dx-texteditor-input {
  font-size: 24px; /* Adjust the font size as needed */
}
</style>
